import React from "react";
import { useFormContext } from "react-hook-form";
import ConfirmStep from "./ui/confirm-step";
import {
  StackMoreFormData,
  StackMoreStepType as StepType,
} from "../pages/StackMore";
import { Asset } from "../types/asset";
import CurrencyFormatter from "../services/currencyFormatterService";

interface ConfirmStackMoreStepProps {
  onStepComplete: () => void;
  onStepBack: () => void;
  onCancel: () => void;
  currentStep: StepType;
  asset: Asset;
}

const ConfirmStackMoreStep: React.FC<ConfirmStackMoreStepProps> = ({
  onStepComplete,
  onStepBack,
  onCancel,
  asset,
}) => {
  const form = useFormContext<StackMoreFormData>();
  const formData = form.getValues();
  const currencyFormatter = new CurrencyFormatter({ locale: "en-ZA" });

  const formattedAmount = formData.stackAmount
    ? currencyFormatter.format(parseFloat(formData.stackAmount), "fiat", "ZAR")
    : "R0.00";

  const transactionDetails = [
    {
      label: "Asset",
      value: asset?.asset.toUpperCase(),
    },
    {
      label: "Stack Name",
      value: `My ${asset?.assetName} Vault`,
    },
  ];

  const description =
    formData.stackType === "wallet"
      ? "Your wallet balance will be checked. You'll be notified if funds are insufficient."
      : `The specified amount will be transferred from your bank account to purchase ${asset?.assetName}.`;

  return (
    <ConfirmStep
      title="Stack More"
      formattedAmount={formattedAmount}
      transactionDetails={transactionDetails}
      description={description}
      buttonText="Stack More"
      onStepComplete={onStepComplete}
      onStepBack={onStepBack}
      onCancel={onCancel}
    />
  );
};

export default ConfirmStackMoreStep;
